import { toast, ToastOptions, UpdateOptions, Id } from "react-toastify";

const defaultOptions: ToastOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "light",
};

export const showToast = {
  success: (message: string, options: Partial<ToastOptions> = {}) =>
    toast.success(message, Object.assign({}, defaultOptions, options)),

  error: (message: string, options: Partial<ToastOptions> = {}) =>
    toast.error(message, Object.assign({}, defaultOptions, options)),

  info: (message: string, options: Partial<ToastOptions> = {}) =>
    toast.info(message, Object.assign({}, defaultOptions, options)),

  warning: (message: string, options: Partial<ToastOptions> = {}) =>
    toast.warning(message, Object.assign({}, defaultOptions, options)),

  // 1. Add Loading (returns an ID)
  loading: (message: string, options: Partial<ToastOptions> = {}) =>
    toast.loading(message, Object.assign({}, defaultOptions, options)),

  // 2. Add Update (to close loader and show result)
  update: (id: Id, options: UpdateOptions) =>
    toast.update(id, options),

  // 3. Add Dismiss
  dismiss: (id?: Id) => toast.dismiss(id),
};